import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/emojis/sleepy.svg';
const _withScopeId = n => (_pushScopeId("data-v-f9c2ad48"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "audience-management-empty-table" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "audience-management-empty-table__image",
    src: _imports_0
}, null, -1));
const _hoisted_3 = { class: "audience-management-empty-table__content" };
const _hoisted_4 = { class: "audience-management-empty-table__title" };
const _hoisted_5 = { class: "audience-management-empty-table__description" };
const _hoisted_6 = { class: "audience-management-empty-table__actions" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon ml--4 icon-upload-14px" }, null, -1));
import router from '@/router';
import bus from '@/helpers/events/bus';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceManagementEmptyTable',
    setup(__props) {
        const createAudience = () => {
            router.push('/base-management/base-audiences/create/');
        };
        const importAudience = () => {
            bus.$emit('open-importation');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.$t('audiences.empty-table.title')), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('audiences.empty-table.description')), 1),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("button", {
                            onClick: importAudience,
                            ref: "button",
                            class: "btn btn-outline-ctx-primary audience-management-empty-table__btn-import"
                        }, [
                            _hoisted_7,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('audiences.import-audience')), 1)
                        ], 512),
                        _createElementVNode("button", {
                            ref: "button",
                            class: "btn audience-management-empty-table__btn-create",
                            onClick: createAudience
                        }, _toDisplayString(_ctx.$t('audiences.create-audience')), 513)
                    ])
                ])
            ]));
        };
    }
});
